import { type ReactNode } from 'react'
import { AlertTriangle, HelpCircle } from 'lucide-react'
import { cn } from '@/lib/utils'

interface FormFieldProps {
  label: string
  hint?: string
  error?: { message?: string }
  required?: boolean
  children: ReactNode
  tooltip?: string
  className?: string
}

export function FormField({
  label,
  hint,
  error,
  required,
  children,
  tooltip,
  className,
}: FormFieldProps) {
  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-center gap-2">
        <label className="text-xs font-mono text-foreground-muted uppercase tracking-widest">
          {label}
          {required && <span className="text-primary ml-1">*</span>}
        </label>
        {tooltip && (
          <div className="group relative">
            <HelpCircle className="w-3.5 h-3.5 text-foreground-muted hover:text-primary transition cursor-help" />
            <div className="absolute left-0 top-full mt-2 w-64 p-3 bg-surface border border-border rounded opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50 pointer-events-none">
              <p className="text-xs text-foreground">{tooltip}</p>
            </div>
          </div>
        )}
      </div>

      {children}

      {hint && !error && <p className="text-xs text-foreground-muted">{hint}</p>}

      {error && (
        <p className="text-xs text-red-400 flex items-center gap-1 animate-fade-in">
          <AlertTriangle className="w-3 h-3" />
          {error.message}
        </p>
      )}
    </div>
  )
}
